import { t, type Static } from 'elysia'

export const StreamerWorkspaceRoleSchema = t.Union([t.Literal('OWNER'), t.Literal('EDITOR'), t.Literal('OPERATOR'), t.Literal('VIEWER')])

export const StreamerWorkspaceSchema = t.Object(
  {
    id: t.String({ minLength: 1 }),
    personalOwnerUserId: t.Nullable(t.String({ minLength: 1 })),
    name: t.String({ minLength: 1 }),
    createdAt: t.String({ format: 'date-time' }),
    updatedAt: t.String({ format: 'date-time' }),
    archivedAt: t.Nullable(t.String({ format: 'date-time' })),
  },
  { additionalProperties: false },
)

export const StreamerWorkspaceMembershipSchema = t.Object(
  {
    id: t.String({ minLength: 1 }),
    workspaceId: t.String({ minLength: 1 }),
    userId: t.String({ minLength: 1 }),
    role: StreamerWorkspaceRoleSchema,
    createdAt: t.String({ format: 'date-time' }),
    updatedAt: t.String({ format: 'date-time' }),
  },
  { additionalProperties: false },
)

export const StreamerWorkspaceBootstrapResponseSchema = t.Object(
  {
    workspace: StreamerWorkspaceSchema,
    membership: StreamerWorkspaceMembershipSchema,
  },
  { additionalProperties: false },
)

export const StreamerWorkspaceParamsSchema = t.Object(
  {
    workspaceId: t.String({ minLength: 1, maxLength: 128 }),
  },
  { additionalProperties: false },
)

export const StreamerWorkspaceLiveLockBodySchema = t.Object(
  {
    locked: t.Boolean(),
  },
  { additionalProperties: false },
)

export const StreamerWorkspaceLiveLockStateSchema = t.Object(
  {
    workspaceId: t.String(),
    locked: t.Boolean(),
    generation: t.String({ pattern: '^[1-9][0-9]*$' }),
    changedByUserId: t.Union([t.String(), t.Null()]),
    updatedAt: t.String({ format: 'date-time' }),
  },
  { additionalProperties: false },
)

export const StreamerWorkspaceLiveLockChangeSchema = t.Composite(
  [
    StreamerWorkspaceLiveLockStateSchema,
    t.Object(
      {
        changed: t.Boolean(),
      },
      { additionalProperties: false },
    ),
  ],
  { additionalProperties: false },
)

export type StreamerWorkspaceRoleDto = Static<typeof StreamerWorkspaceRoleSchema>
export type StreamerWorkspaceDto = Static<typeof StreamerWorkspaceSchema>
export type StreamerWorkspaceMembershipDto = Static<typeof StreamerWorkspaceMembershipSchema>
export type StreamerWorkspaceBootstrapResponse = Static<typeof StreamerWorkspaceBootstrapResponseSchema>
export type StreamerWorkspaceParams = Static<typeof StreamerWorkspaceParamsSchema>
export type StreamerWorkspaceLiveLockBody = Static<typeof StreamerWorkspaceLiveLockBodySchema>
export type StreamerWorkspaceLiveLockStateDto = Static<typeof StreamerWorkspaceLiveLockStateSchema>
export type StreamerWorkspaceLiveLockChangeDto = Static<typeof StreamerWorkspaceLiveLockChangeSchema>
